/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-07 16:47:37
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-09-17 12:25:23
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/index.js
 * @Description: p1
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './index.css';
import Stage from '../components/Stage';
import setChart from './chart';
import Chart from '../components/Chart';
import { Title38 } from '../components/Titles';
import TooltipDrawer from '../components/TooltipDrawer';
import Form from './Form';

class P38 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chartTitle: [],
      chartList: [],
      chartColorList: [],
    }
  }

  render() {
    const { chartTitle, chartList, chartColorList } = this.state;
    return (
      <Stage>
        <Title38 pageNumber="4.1">索尼｜全网好感度分析
        </Title38>

        <div className={s.content}>
          <div>
            <div contentEditable className={s.des}>
              2022年，索尼口碑以正面内容为主，中立与负面内容相对影响较小。
            </div>
            <div contentEditable className={s.des}>
              其中，4月的正向事件主要为成立移动公司。5月口碑表现最好，但争议也较多，上新订阅服务补差价机制带来了负面口碑小高峰。7月-10月趋于平稳，推出电竞品牌INZONE、一系列新品的发布以及对Fromsoftware和Savage Game Studios的收购等事件带来持续的正面口碑，但因受77风波的牵连、上调PS5售价及PS5服务器崩溃对品牌产生不良影响。
            </div>
          </div>

          <div className={s.uiWrapper}>
            
            <div className={s.chartWrapper}>
              <TooltipDrawer
                  style={{ width: '100%', height: '100%' }}
                  formContent={<Form onChange={values => this.setState({ ...values })} />}>
                  <Chart options={setChart({
                    label: chartTitle,
                    list: chartList,
                    color: chartColorList,
                  })} />
                </TooltipDrawer>
            </div>
            
          </div>
        </div>
      </Stage>
    );
  }
}

export default withStyles(s)(P38);



// WEBPACK FOOTER //
// src/routes/visualChart/P38/index.js